import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import {
  OwnershipTransferStep,
  OwnershipTransferActionType,
  MessageContent,
  PopupEnum,
  PopupMessageContent,
  FormSendType,
  RequestStatus,
  FutureBusinessAccountType,
  EquipmentPaymentObligation,
  OwnershipTransferActionSubType
} from './Constant/Constant';


export const fetchExistingRequests = createAsyncThunk('OwnershipTransfer/fetchExistingRequests', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('fetchExistingOwnershipTransferRequests', [data]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});

export const validateCustomer = createAsyncThunk('OwnershipTransfer/validateCustomer', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('ownershipTransferCustomerValidation', data);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});

export const addOwnershipTransferRequest = createAsyncThunk('OwnershipTransfer/addOwnershipTransferRequest', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('addOwnershipTransferRequest', data);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});

export const updateOwnershipTransferRequest = createAsyncThunk(
  'OwnershipTransfer/updateOwnershipTransferRequest',
  async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
      const result = await ProviderManager.getProviderData('updateOwnershipTransferRequest', data);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return error;
    }
  },
);
export const cancelOwnershipTransferRequest = createAsyncThunk(
  'OwnershipTransfer/cancelOwnershipTransferRequest',
  async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
      const result = await ProviderManager.getProviderData('updateOwnershipTransferRequest', data);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return error;
    }
  },
);

export const validateOwnershipTransferStatus = createAsyncThunk(
  'OwnershipTransfer/validateOwnershipTransferStatus',
  async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
      const result = await ProviderManager.getProviderData('ValidateOwnershipTransferDashboardStatus', data);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return error;
    }
  },
);
export const uploadFileOwnershipTransferRequest = createAsyncThunk('OwnershipTransfer/uploadFileOwnershipTransferRequest', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var result = await ProviderManager.getProviderData('uploadFileOwnershipTransferRequest', data);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return { ...state, error: true };
  }
});


const initialState = {
  jetConnection: false,
  currentStep: '',
  selectedActionType: '',
  selectedActionSubType: '',
  futureAccountType: '',
  currentPopUp: '',
  currentPopupData: null,
  showPopup: false,
  selectedPhoneNumber: '',
  customerValidationResult: null,
  currentEquipmentObligations: [],
  banList: [],
  selectedBan: '',
  responsibleForNextPayments: EquipmentPaymentObligation.None,
  customerHetPay: '',
  customerOrgName: '',
  customerIdNumber: '',
  customerAccountType: '',
  generalMessage: null,
  subscriberPersonalData: {
    firstName: '',
    lastName: '',
    idNumber: '',
  },
  subscriberAddress: {
    city: '',
    street: '',
    houseNum: '',
    zipCode: '',
  },
  contactPersonSendFormType: { type: '', sms: '', email: '' },
  subscriberSendFormType: { type: '', sms: '', email: '' },
  serviceManagerEmail: '',
  dashboardData: [],
  dashboardRequestCompleted: false,
  fuNumber: '',
  requestId: '',
  invalidLineList: [],
  maxSizeFileError: false
};

const OwnershipTransferSlice = createSlice({
  name: 'OwnershipTransfer',
  initialState: initialState,

  reducers: {
    resetState: () => initialState,

    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
      return state;
    },
    setSelectedActionType: (state, action) => {
      state.selectedActionType = action.payload;
      if (action.payload == OwnershipTransferActionType.PrivateToBusiness) {
        state.futureAccountType = FutureBusinessAccountType.Private;
      } else if (action.payload == OwnershipTransferActionType.FullFundingToSeparate) {
        state.futureAccountType = FutureBusinessAccountType.BusinessSplit;
      } else {
        state.futureAccountType = FutureBusinessAccountType.Undefined;
      }
    },
    setSelectedActionSubType: (state, action) => {
      state.selectedActionSubType = action.payload;
    },
    setFutureAccountType: (state, action) => {
      state.futureAccountType = action.payload;
    },
    setBanList: (state, action) => {
      if (action.payload.payload.length > 0) {
        state.banList = action.payload.payload;
      }
    },
    setSelectedBan: (state, action) => {
      state.selectedBan = action.payload;
    },
    setShowPopUp: (state, action) => {
      if (!action.payload) {
        state.currentPopUp = '';
        state.currentPopupData = null;
      }
      state.showPopup = action.payload;
      return state;
    },
    setCurrentPopUp: (state, action) => {
      state.showPopup = true;
      state.currentPopUp = action.payload.currentPopUp;
      state.currentPopupData = action.payload.currentPopupData;
      return state;
    },
    setSelectedPhoneNumber: (state, action) => {
      state.selectedPhoneNumber = action.payload;
      state.customerValidationResult = null;
    },
    setContactPersonSendFormType: (state, action) => {
      if (action.payload.type !== undefined) {
        state.contactPersonSendFormType.type = action.payload.type;
      }
      if (action.payload.value !== undefined) {
        if (state.contactPersonSendFormType.type == FormSendType.sms || action.payload.type == FormSendType.sms) {
          state.contactPersonSendFormType.sms = action.payload.value;
        } else {
          state.contactPersonSendFormType.email = action.payload.value;
        }
      }
    },
    setSubscriberSendFormType: (state, action) => {
      if (action.payload.type !== undefined) {
        state.subscriberSendFormType.type = action.payload.type;
      }
      if (action.payload.value !== undefined) {
        if (state.subscriberSendFormType.type == FormSendType.sms || action.payload.type == FormSendType.sms) {
          state.subscriberSendFormType.sms = action.payload.value;
        } else {
          state.subscriberSendFormType.email = action.payload.value;
        }
      }
    },
    setServiceManagerEmail: (state, action) => {
      state.serviceManagerEmail = action.payload;
    },
    setSelectedResponsible: (state, action) => {
      state.responsibleForNextPayments = action.payload;
    },
    saveToHistory: (state, action) => {
      return state;
    },
    setGeneralMessage: (state, action) => {
      state.generalMessage = action.payload;
    },
    setSubscriberPersonalData: (state, action) => {
      if (action.payload.firstName !== undefined) {
        state.subscriberPersonalData.firstName = action.payload.firstName;
      }
      if (action.payload.lastName !== undefined) {
        state.subscriberPersonalData.lastName = action.payload.lastName;
      }
      if (action.payload.idNumber !== undefined) {
        state.subscriberPersonalData.idNumber = action.payload.idNumber;
      }
    },
    setSubscriberAddress: (state, action) => {
      state.subscriberAddress.city = action.payload.city;
      state.subscriberAddress.street = action.payload.street;
      state.subscriberAddress.houseNum = action.payload.houseNum;
      state.subscriberAddress.zipCode = action.payload.zipCode
    },
    setIsJetConnection: (state, action) => {
      state.jetConnection = action.payload;
    }

  },
  extraReducers: {
    [fetchExistingRequests.pending]: (state) => {
      state.dashboardData = [];
      state.dashboardRequestCompleted = false;
    },
    [fetchExistingRequests.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        state.dashboardRequestCompleted = true;
        if (action.payload?.length > 0) {
          state.dashboardData = action.payload;
          state.currentStep = OwnershipTransferStep.Dashboard;
        } else {
          state.currentStep = OwnershipTransferStep.SelectActionType;
        }
      } else {
        state.generalMessage = MessageContent.GeneralError;
        state.currentStep = OwnershipTransferStep.GeneralMessage;
      }
    },
    [validateCustomer.pending]: (state) => {
      state.customerValidationResult = null;
      state.currentEquipmentObligations = [];
    },
    [validateCustomer.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        if (action.payload.success) {
          if (!action.payload.message) {
            let resultText = 'המנוי שייך לארגון וניתן להעברת הבעלות';
            if (state.selectedActionType == OwnershipTransferActionType.PrivateToBusiness) {
              resultText = `המנוי שייך ל${window.Config.brand_Name_HE} וניתן להעברת הבעלות`;
            }
            const validationResult = {
              accepted: true,
              resultText: resultText,
            };
            state.customerIdNumber = action.payload.customerIdNumber;
            state.customerAccountType = action.payload.accountType;

            if (state.selectedActionType != OwnershipTransferActionType.PrivateToBusiness) {
              state.subscriberPersonalData.idNumber = action.payload.customerIdNumber;
              state.subscriberPersonalData.firstName = action.payload.customerFirstName;
              state.subscriberPersonalData.lastName = action.payload.customerLastName;
            }
            state.customerValidationResult = validationResult;
            if (action.payload.equipmentObligations?.length > 0) {
              state.currentEquipmentObligations = action.payload.equipmentObligations;
            }
          } else {
            if (action.payload.message == 'SwitchCode') {
              let resultText = 'המנוי שייך לארגון וניתן להעברת הבעלות';
              const validationResult = {
                accepted: true,
                resultText: resultText,
              };
              state.customerValidationResult = validationResult;
              state.currentPopupData = PopupMessageContent.DataAccount;
              state.currentPopUp = PopupEnum.CustomerValidationResult;
              if (action.payload.equipmentObligations?.length > 0) {
                state.currentEquipmentObligations = action.payload.equipmentObligations;
              }
              state.showPopup = true;
            }
          }
        } else {
          if (action.payload.message == RequestStatus.TransferredForManualProcessing) {
            state.fuNumber = action.payload.fuNumber;
            state.generalMessage = MessageContent.ManualProgress;
            state.currentStep = OwnershipTransferStep.GeneralMessage;
            return state;
          }
          if (action.payload.message == 'InvalidOrgId') {
            state.customerHetPay = action.payload.customerOrgId;
            state.customerOrgName = action.payload.customerOrgName;
            state.currentPopupData = PopupMessageContent.MemberOfDifferentOrg;
          } else if (action.payload.message == 'InvalidSubStatus') {
            state.currentPopupData = PopupMessageContent.ErrorSubStatus;
          } else if (action.payload.message == 'InvalidNPStatus') {
            state.currentPopupData = PopupMessageContent.ErrorNPStatus;
          } else if (action.payload.message == 'Abroad') {
            state.currentPopupData = PopupMessageContent.ErrorAbroad;
          } else if (action.payload.message == 'AccountNotFound') {
            if (state.selectedActionType == OwnershipTransferActionType.PrivateToBusiness) {
              let validationResult;
              if (state.jetConnection) {
                validationResult = {
                  accepted: false,
                  resultText: 'לא נמצא מנוי. אפשר לחפש מנוי אחר ',
                };
              }
              else {
                validationResult = {
                  accepted: false,
                  resultText: 'לא נמצא מנוי. אפשר לחפש מנוי אחר או לפנות לאחראי/ת השירות',
                };
              }
              state.customerValidationResult = validationResult;
              return state;
            } else {
              state.currentPopupData = PopupMessageContent.AccountNotFound;
            }
          } else if (action.payload.message == 'InvalidAccountType') {
            state.currentPopupData = PopupMessageContent.ValidateCustomerGeneralError;
          } else if (action.payload.message == 'BusinessAccountType') {
            state.currentPopupData = PopupMessageContent.BusinessAccountType;
          } else if (action.payload.message == 'AdditionalId') {
            state.currentPopupData = PopupMessageContent.ValidateCustomerGeneralError;
          } else if (action.payload.message == 'InProgress') {
            state.currentPopupData = PopupMessageContent.InProgress;
          } else {
            state.generalMessage = MessageContent.GeneralError;
            state.currentStep = OwnershipTransferStep.GeneralMessage;
            return state;
          }

          state.currentPopUp = PopupEnum.CustomerValidationResult;
          state.showPopup = true;

        }
      } else {
        state.generalMessage = MessageContent.GeneralError;
        state.currentStep = OwnershipTransferStep.GeneralMessage;
        return state;
      }
    },
    [addOwnershipTransferRequest.pending]: (state) => { },
    [addOwnershipTransferRequest.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        if (action.payload.boolean) {
          state.currentStep = OwnershipTransferStep.SuccessPage;
        } else {
          state.generalMessage = MessageContent.GeneralError;
          state.currentStep = OwnershipTransferStep.GeneralMessage;
        }
      } else {
        state.generalMessage = MessageContent.GeneralError;
        state.currentStep = OwnershipTransferStep.GeneralMessage;
      }
    },
    [uploadFileOwnershipTransferRequest.pending]: (state) => { },
    [uploadFileOwnershipTransferRequest.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        if (action.payload.Body.success) {
          state.currentStep = OwnershipTransferStep.SuccessPageBulkRequest;
        }
        else {
          if (action.payload.Body.message == 'MaxRowsExceeded') {
            state.maxSizeFileError = true;
          }
          else {
            state.invalidLineList = action.payload.Body.invalidLineList;
            state.currentStep = OwnershipTransferStep.ErrorPageBulkRequest;
          }

        }

      }
    },
    [updateOwnershipTransferRequest.pending]: (state) => { },
    [updateOwnershipTransferRequest.fulfilled]: (state, action) => {
      if ((action.payload?.isAxiosError && action.payload.errorCode) || !action.payload.boolean) {
        state.currentPopUp = '';
        state.currentPopupData = null;
        state.showPopup = false;
        state.generalMessage = MessageContent.GeneralError;
        state.currentStep = OwnershipTransferStep.GeneralMessage;
        return state;
      }

      let newData = state.dashboardData.map((row) => {
        if (row.id === action.payload.param) {
          if (row.statusCodeDescription == RequestStatus.AwaitingContactPersonSignature) {
            return {
              ...row,
              contactPersonFormMethodValue: state.contactPersonSendFormType.type == FormSendType.email ? state.contactPersonSendFormType.email : state.contactPersonSendFormType.sms,
            };
          }
          else if (row.statusCodeDescription == RequestStatus.AwaitingSubscriberSignature) {
            return {
              ...row,
              contactPersonFormMethodValue: state.contactPersonFormMethodValue.type == FormSendType.email ? state.contactPersonFormMethodValue.email : state.contactPersonFormMethodValue.sms,
            };
          }
          else if (row.statusCodeDescription == RequestStatus.AwaitingForJoin || row.statusCodeDescription == RequestStatus.SignedAwaitingForJoin) {
            return {
              ...row,
              subscriberFormMethodValue: state.subscriberFormMethodValue.type == FormSendType.email ? state.subscriberFormMethodValue.email : state.subscriberFormMethodValue.sms,
            };
          }
        }
        return row;
      });

      state.dashboardData = newData;

      state.currentPopUp = '';
      state.currentPopupData = null;
      state.showPopup = false;
      const currentRow = newData.find(r => r.id == action.payload.param);
      if (currentRow.statusCodeDescription == RequestStatus.AwaitingForJoin || currentRow.statusCodeDescription == RequestStatus.SignedAwaitingForJoin) {
        state.currentStep = OwnershipTransferStep.ResendMLSuccessPage;
        state.subscriberSendFormType.sms = currentRow.subscriberPhoneNumber;
      }
      else {
        state.currentStep = OwnershipTransferStep.ResendSuccessPage;
      }

    },

    [cancelOwnershipTransferRequest.fulfilled]: (state, action) => {
      if ((action.payload?.isAxiosError && action.payload.errorCode) || !action.payload.boolean) {
        state.currentPopUp = '';
        state.currentPopupData = null;
        state.showPopup = false;
        state.generalMessage = MessageContent.GeneralError;
        state.currentStep = OwnershipTransferStep.GeneralMessage;
        return state;
      }

      let newData = state.dashboardData.map((row) => {
        if (row.id === state.requestId) {
          return {
            ...row,
            statusCodeDescription: RequestStatus.Cancelled,
          };
        }
        return row;
      });

      state.dashboardData = newData;
      state.currentPopUp = PopupEnum.CustomerValidationResult;
      state.currentPopupData = PopupMessageContent.CancelSuccess;
      state.showPopup = true;
    },
    [validateOwnershipTransferStatus.padding]: (state) => { state.requestId = '' },
    [validateOwnershipTransferStatus.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {

        let newData = state.dashboardData.map((row) => {
          if (row.id === action.payload.id) {
            return {
              ...row,
              statusCodeDescription: action.payload.statusCodeDescription,
              fU_Number: action.payload.fU_Number,
            };
          }
          return row;
        });

        state.dashboardData = newData;
        state.requestId = action.payload.id;
        state.currentPopUp = PopupEnum.RowValidationResult;
        state.currentPopupData = newData.find(r => r.id == action.payload.id);
        state.showPopup = true;

      }
    },
  },
});

export const {
  resetState,
  setCurrentStep,
  setCurrentPopUp,
  setShowPopUp,
  saveToHistory,
  setGeneralMessage,
  setSelectedActionType,
  setContactPersonSendFormType,
  setSubscriberSendFormType,
  setSelectedPhoneNumber,
  setSelectedResponsible,
  setSubscriberPersonalData,
  setSubscriberAddress,
  setFutureAccountType,
  setSelectedBan,
  setBanList,
  setIsJetConnection,
  setSelectedActionSubType,
  setServiceManagerEmail
} = OwnershipTransferSlice.actions;

export default OwnershipTransferSlice.reducer;
